
import ExportXlsx from '@/components/ExportXlsxBtn/index.vue';
import { cookContent } from '@/common/export-xlsx';

export default {
  components: {
    ExportXlsx: ExportXlsx
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    xlsxHeader: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    formHeader: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    formData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pageSizes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pageSize: {
      type: Number,
      default: 1
    }
  },

  data: function data() {
    return {
      exportContent: [],
      pagesize: this.pageSize,
      total: 0,
      currentPage: 1
    };
  },


  computed: {
    actData: function actData() {
      return this.formData.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize);
    },
    exportHeader: function exportHeader() {
      var header = {};
      this.formHeader.forEach(function (item) {
        header[item.value] = item.label;
      });
      return header;
    }
  },

  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pagesize = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
    },
    handleExport: function handleExport() {
      var _this = this;

      this.exportContent = cookContent(this.formData, this.xlsxHeader);
      this.$nextTick(function () {
        _this.$refs.exportSheetCon.exportSheet();
      });
    }
  }
};